import { Account } from 'api/Account/types';
import { getAccountsRequest } from 'api/Account/api';
import { Pagination } from 'common/types/Pagination';

import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import omit from 'lodash/omit';

export const useAccounts = () => {
  const { t } = useTranslation();
  
  const [ isLoading, setLoading ] = useState(false);
  const [ accounts, setAccounts ] = useState<Account[]>([]);
  const [ pagination, setPagination ] = useState<Pagination | undefined>();
  const [ error, setError ] = useState('');

  const getAccounts = useCallback((page: string, pageSize: string, search = '', abortController: AbortController) => {
    setLoading(true);
    setError('');

    getAccountsRequest(page, pageSize, search, abortController)
      .then((response) => {
        setAccounts(response.data.results);
        setPagination(omit(response.data, 'results'));
      })
      .catch((error) => {
        if (!abortController?.signal.aborted) {
          setError(error?.response?.data?.message || t('errors.server_error_try_again'));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setLoading(false);
        }
      });
  }, [ t ]);

  return {
    getAccounts,
    accounts,
    setAccounts,
    isLoading,
    error,
    pagination,
  };
};
